import React from "react";
import { Link } from "react-router-dom";

import { FromInt } from "../../helpers/NumberTools";
import { jalaliDateWithTime } from "../../helpers/convertDate.helper";

//icon
import ApartmentIcon from "@mui/icons-material/Apartment";
import SubjectIcon from "@mui/icons-material/Subject";
import QuizIcon from "@mui/icons-material/Quiz";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

const TicketCard = (props) => {
  const { ticket } = props;
  return (
    <div className="row cards">
      <div className="col-12 ">
        <ApartmentIcon className="m-1" />
        {FromInt(ticket.department.text)}
      </div>
      <div className="col-12 ">
        <SubjectIcon className="m-1" /> {FromInt(ticket.subject)}
      </div>
      <div className="col-12 ">
        <QuizIcon className="m-1" /> {FromInt(ticket.status)}
      </div>
      <div className="col-12 ">
        <PriorityHighIcon className="m-1" /> {FromInt(ticket.priority.text)}
      </div>
      <div className="col-12  " >
        <InsertInvitationIcon className="m-1" />{" "}
        <span dir="ltr">{FromInt(jalaliDateWithTime(ticket.createdAt))}</span>
      </div>
      <div className="row justify-content-center mt-3">
        {" "}
        <div className="col-md-5 col-8 text-center">
          <Link
            to={`/ticket/${ticket.id}`}
            className="btn btn-primary w-100 d-flex justify-content-center align-items-center"
          >
            مشاهده درخواست
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TicketCard;
